export const WRAPPED_MARKUP_KEY = '__wrappedMarkup__';
